import type { DomainGuide } from '@/components/guide/guide-types';

import th from './th.json';
import en from './en.json';
import zh from './zh.json';
import vi from './vi.json';
import km from './km.json';
import lo from './lo.json';
import my from './my.json';

/**
 * Help catalog for the `reconcile` domain.
 *
 * Read out of `apps/admin/src/reconcile/`, not out of the spec. The five facts
 * that make a green card mean less than it looks:
 *
 *   - `count` is `rows.length` of an already-LIMITed query, so on the 38 checks
 *     capped at 100 a count of 100 means "at least 100"; on
 *     `checkWalletBrandlessRows` it counts RELATIONS (max 2) standing for
 *     however many rows
 *   - `error` feeds `foundAny` but NOT `numDrift`, so a red run can read
 *     "0 with drift"
 *   - `advisory` feeds neither, so a run reads "Clean" while carrying one — and
 *     `RECONCILE_ADVISORY_LABELS` demotes two real finance checks on dev
 *   - the two `[gated on backfill]` journal checks report `ok` over an empty
 *     universe; nothing is skipped, so the skipped-streak check never sees them
 *   - samples are capped at 20 and dropped whole above a 256KB budget, with no
 *     marker — the row just stops being clickable
 */
export const reconcileGuide: DomainGuide = {
  domain: 'reconcile',
  pages: [
    {
      id: 'reconcile.latest',
      route: '/reconcile (Latest run)',
      permission: 'reconcile:read',
      status: 'live',
      fields: [
        { key: 'overall', kind: 'status' },
        { key: 'ranAt', kind: 'date' },
        { key: 'checksRun', kind: 'count' },
        { key: 'numDrift', kind: 'count' },
        { key: 'numAdvisory', kind: 'count' },
        { key: 'check', kind: 'text' },
        { key: 'checkStatus', kind: 'status' },
        { key: 'count', kind: 'count' },
        { key: 'sample', kind: 'text' },
      ],
      cautionCount: 9,
      warningCount: 0,
    },
    {
      id: 'reconcile.history',
      route: '/reconcile (History)',
      permission: 'reconcile:read',
      status: 'live',
      fields: [
        { key: 'ranAt', kind: 'date' },
        { key: 'overall', kind: 'status' },
        { key: 'numDrift', kind: 'count' },
        { key: 'numAdvisory', kind: 'count' },
      ],
      cautionCount: 6,
      warningCount: 0,
    },
  ],
  copy: { th, en, zh, vi, km, lo, my },
};
